import React from "react";

const GROUPS = [["rent_cm", "Rent & PACT Fee"], ["savings", "Savings deposit & withdraw"], ["ncn", "NCNs"], ["corrections", "Corrections"]];
const iso = (d) => d.toLocaleDateString("en-CA", { timeZone: "America/New_York" });
const PRESETS = {  // worked out from today's date in New York
  week: () => { const t = iso(new Date()); const d = new Date(`${t}T12:00:00Z`); d.setUTCDate(d.getUTCDate() - ((d.getUTCDay() + 6) % 7)); return [d.toISOString().slice(0, 10), t]; },
  month: () => { const t = iso(new Date()); return [`${t.slice(0, 8)}01`, t]; },
  all: () => ["", ""],
};
const chip = (on) => `px-2.5 py-1 rounded-full border font-mono text-[9px] tracking-[0.14em] uppercase transition-colors ${on ? "border-nex-gold text-nex-gold bg-nex-gold/10" : "border-white/10 text-nex-muted hover:text-nex-silver"}`;
const field = "[color-scheme:dark] bg-black/40 border border-white/10 focus:border-nex-gold/60 outline-none text-nex-silver font-mono text-[11px] px-2 py-1.5 rounded-sm";

export const EMPTY_LEDGER_FILTERS = { date_from: "", date_to: "", groups: "" };

/** Combinable group chips + date range for a resident's ledger. Value: { date_from, date_to, groups: "a,b" }. */
export function LedgerFilters({ value: f, onChange }) {
  const put = (patch) => onChange({ ...f, ...patch });
  const picked = f.groups ? f.groups.split(",") : [];
  const flip = (g) => put({ groups: (picked.includes(g) ? picked.filter((y) => y !== g) : [...picked, g]).join(",") });
  const preset = (k) => { const [a, b] = PRESETS[k](); put({ date_from: a, date_to: b }); };
  const which = !f.date_from && !f.date_to ? "all" : ["week", "month"].find((k) => PRESETS[k]().join() === `${f.date_from},${f.date_to}`);
  return (
    <div data-testid="ledger-filters" className="space-y-2 py-1">
      <div className="flex flex-wrap items-center gap-2" data-testid="fin-ledger-groups">
        <span className="nds-label-dim text-[9px]">Show</span>
        {GROUPS.map(([k, l]) => <button key={k} type="button" onClick={() => flip(k)} aria-pressed={picked.includes(k)} data-testid={`fin-ledger-group-${k}`} className={chip(picked.includes(k))}>{l}</button>)}
        {picked.length > 0 && <button type="button" onClick={() => put({ groups: "" })} data-testid="fin-ledger-group-clear" className="text-[11px] text-nex-muted hover:text-nex-gold">Clear</button>}
      </div>
      <div className="flex flex-wrap items-center gap-2" data-testid="fin-ledger-date-bar">
        <span className="nds-label-dim text-[9px]">Date</span>
        {[["week", "This week"], ["month", "This month"], ["all", "All dates"]].map(([k, l]) => (
          <button key={k} type="button" onClick={() => preset(k)} data-testid={`fin-ledger-date-${k}`} className={chip(which === k)}>{l}</button>))}
        <input type="date" value={f.date_from} onChange={(e) => put({ date_from: e.target.value })} data-testid="fin-ledger-filter-from" aria-label="From date" className={field} />
        <span className="text-nex-muted text-xs">to</span>
        <input type="date" value={f.date_to} onChange={(e) => put({ date_to: e.target.value })} data-testid="fin-ledger-filter-to" aria-label="To date" className={field} />
      </div>
    </div>
  );
}
